// mode Z: preview
import _ from 'lodash'
import { useSlideStore } from '~/store/slide'
import { useWishStore } from '~/store/wish'

export const useSlideModePreview = () => {
  const slideStore = useSlideStore()
  const wishStore = useWishStore()


  const isFistTime = ref(true)
  const indexLatestShow = ref(null as any)
  const currentWish = ref(null as any) // for next, prev 



  function main() {
    slideStore.index++
    slideStore.showNewWishIcon = false
    slideStore.view = 'wish'

    // เปิดเข้ามาครั้งแรก -> จะเล่นรูปสุดท้ายก่อน
    if(isFistTime.value && indexLatestShow.value === null) {
      const wishes = wishStore.allWishDatabase
      indexLatestShow.value = wishes?.length - 1
    }

    // next or prev 
    if(currentWish.value) {
      const data = _.cloneDeep(currentWish.value)
      currentWish.value = null
      return {
        type: 'wish',
        data: data,
      } 
    }

    let newWishList = wishStore.getNewDocIdList()
    let currentView = newWishList.length > 0 ? 'new_wish' : 'wish'

    if(currentView === 'new_wish') {
      slideStore.showNewWishIcon = true
      const newWishId = newWishList[0]
      const newWishData = wishStore.getWishDataById(newWishId)
      wishStore.newWishes.shift();
      currentWish.value = null

      return {
        type: 'wish',
        data: newWishData,
      }
    }

    // เข้ามาครั้งแรก -> จะเล่น wish ตัวล่าสุดก่อน
    if(isFistTime.value) {
      const wishData = _.last(wishStore.allWishDatabase)
      isFistTime.value = false
      return {
        type: 'wish',
        data: wishData,
      }
    }

    slideStore.checkNextSlide()
    const docId = wishStore.queue.shift() //ดึงตัวแรกออกจาก queue
    const wishData = wishStore.getWishDataById(docId)
    currentWish.value = null
    return {
      type: 'wish',
      data: wishData,
    }
  }

  async function prev () {
    const wishStore = useWishStore()
    const wishes = wishStore.allWishDatabase
  
    let prevImage = wishes[indexLatestShow.value - 1]

    // reset to last image
    if(!prevImage) {
      const lastIndex = wishStore.allWishDatabase.length - 1
      prevImage = wishStore.allWishDatabase[lastIndex]
    }

     // set lastest index
    const currentIndex = _.findIndex(wishes, w => w.docId === prevImage?.docId)
    indexLatestShow.value = currentIndex
    currentWish.value = prevImage
  }
  
  async function next () {
    const wishStore = useWishStore()
    const wishes = wishStore.allWishDatabase

    if(indexLatestShow.value === wishes.length) {
      return
    }
  
    let nextImage = wishes[indexLatestShow.value + 1]
    // reset to first image
    if(!nextImage) {
      nextImage = wishStore.allWishDatabase[0]
    }

    // set lastest index
    const currentIndex = _.findIndex(wishes, w => w.docId === nextImage?.docId)
    indexLatestShow.value = currentIndex
    currentWish.value = nextImage
  }


  async function selectTargetWish(wish: any) {
    const targetIndex = _.findIndex(wishStore.allWishDatabase, (w) => w?.docId == wish?.docId)
    console.log('targetIndex ===>',targetIndex)
    // set latest index
    const currentIndex =  parseInt(targetIndex)
    indexLatestShow.value = currentIndex
    console.log('indexLatestShow --->',indexLatestShow.value)
    currentWish.value = wish

  }




  return {
    main,
    prev,
    next,
    selectTargetWish
  }

}